<div class="cd-overlay" *ngIf="visible" (click)="answer(false)">
  <div class="cd-box" (click)="$event.stopPropagation()" [class.cd-danger]="config.danger" role="dialog" aria-modal="true">

    <div class="cd-icon-wrap" [class.cd-icon-danger]="config.danger" [class.cd-icon-info]="!config.danger">
      <svg *ngIf="config.danger" width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M12 9v4m0 3h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg *ngIf="!config.danger" width="22" height="22" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
        <path d="M12 8v4m0 4h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </div>

    <div class="cd-content">
      <h4 class="cd-title">{{ config.title || (config.danger ? 'Confirm Delete' : 'Confirm Action') }}</h4>
      <p class="cd-message">{{ config.message }}</p>
    </div>

    <div class="cd-actions">
      <button class="cd-btn cd-btn-cancel" (click)="answer(false)">{{ config.cancelLabel || 'Cancel' }}</button>
      <button class="cd-btn" [class.cd-btn-danger]="config.danger" [class.cd-btn-confirm]="!config.danger"
        (click)="answer(true)">{{ config.confirmLabel || 'Confirm' }}</button>
    </div>

  </div>
</div>
